import React, { useEffect, useState } from 'react';
import {
  CommonHeader,
  Loader,
  UploadModal,
  ErrorSuccessModal,
} from '../../../components/commons';
import ClientDocumentSummary from '../../../components/OpenItems/Client/ClientDocumentSummary';
import { CommentsModal } from '../../../components/OpenItems';
import { DocumentSummaryHeader } from '../../../constant/tableHeadersConstants/openItemsHeadersConst';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import {
  resetOpenItemsError,
  resetOpenItemsSuccess,
  getAdminOpenItemsSingleAction,
  uploadClientOpenItemsAction,
  addOpenItemCommentsAction,
  getAllOpenItemCommentsAction,
  resetOpenItemsCommentList
} from '../../../redux/openItems';
import { resetSession } from '../../../redux/auth';
import {
  AddOpenItemCommentPayload,
  FileDataType,
  GetAllOpenItemCommentsPayload,
  GetSingleOpenItemPayload,
  ItemDataType,
  UploadOpenItemsPayload
} from '../../../commonTypes/openItemsTypes';
import {
  OpenItemsCommentType,
  SingleOpenItemDetailsType,
  SingleOpenItemDocumentType
} from '../../../redux/openItems/openItemsTypes';
import toast, { Toaster } from 'react-hot-toast';


type AppProps = {
  history?: any;
  fetching: boolean;
  commentsFetching: boolean;
  commentsSuccess: number | null;
  token: string | null;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  openItemsCommentsList: [] | OpenItemsCommentType[];
  adminOpenItemSingle: SingleOpenItemDetailsType;
  dispatchResetOpenItemsError: () => void;
  dispatchResetOpenItemsSuccess: () => void;
  dispatchGetSingleOpenItem: (data: GetSingleOpenItemPayload) => void;
  dispatchUploadClientOpenItemAction: (data: UploadOpenItemsPayload) => void;
  dispatchResetSession: () => void;
  dispatchAddOpenItemCommentsAction: (data: AddOpenItemCommentPayload) => void;
  dispatchGetAllOpenItemCommentsAction: (data: GetAllOpenItemCommentsPayload) => void;
  dispatchResetOpenItemCommentsListAction: () => void;
}

const ClientViewOpenItem = ({
  fetching,
  commentsFetching,
  commentsSuccess,
  token,
  error,
  success,
  history,
  statusCode,
  adminOpenItemSingle,
  openItemsCommentsList,
  dispatchGetSingleOpenItem,
  dispatchResetOpenItemsError,
  dispatchResetOpenItemsSuccess,
  dispatchUploadClientOpenItemAction,
  dispatchAddOpenItemCommentsAction,
  dispatchGetAllOpenItemCommentsAction,
  dispatchResetOpenItemCommentsListAction,
  dispatchResetSession
}: AppProps) => {

  const search = useLocation();
  const arr = search.pathname.split('/');
  const jobId = arr[arr?.length - 1];
  const client_code = arr[3];

  const [showFileUploadModal, setShowFileUploadModal] = useState<boolean>(false);
  const [finalFileData, setFinalFileData] = useState<any[]>([]);
  const [openItemId, setOpenItemId] = useState<number | undefined>(undefined);
  const [showCommentModal, setShowCommentModal] = useState<boolean>(false);
  const [commentsModalData, setCommentsModalData] = useState<any>();
  const [allOpenItemComments, setAllOpenItemComments] = useState<[] | OpenItemsCommentType[]>([]);
  const [itemId, setItemId] = useState<number | null>(null);

  // Getting all data for single open item
  useEffect(() => {
    dispatchResetOpenItemsError();
    setFinalFileData([]);
    dispatchResetOpenItemsSuccess();
    if (token && jobId) {
      let finalData = {
        token,
        jobId: +jobId
      }
      dispatchGetSingleOpenItem(finalData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Setting comments list for that item
  useEffect(() => {
    if (openItemsCommentsList) {
      setAllOpenItemComments(openItemsCommentsList);
    }
  }, [openItemsCommentsList]);

  // Setting already uploaded document list
  useEffect(() => {
    if (
      adminOpenItemSingle?.hasOwnProperty('documents') &&
      adminOpenItemSingle?.documents?.length
    ) {
      let uploadData: any = [];
      adminOpenItemSingle?.documents?.map((document: SingleOpenItemDocumentType) => {
        uploadData.push({
          item_id: document?.item_id,
          file_data: document?.upload
        });
      })
      setFinalFileData(uploadData)
    }
  }, [adminOpenItemSingle]);

  const handleToggleFileUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  }

  const handleToggleCommentsModal = () => {
    setShowCommentModal(!showCommentModal);
  }

  const handleSetOpenItemId = (id: number | undefined) => {
    setOpenItemId(id);
  }

  const handleUploadedFileData = (fData: any) => {
    setShowFileUploadModal(false);
    toast.success('Document Added!', {
      duration: 2000
    });

    let tempFileData = JSON.parse(JSON.stringify(finalFileData));

    const isIdPresent = tempFileData.find((id: any) => id.item_id === openItemId);

    if (!isIdPresent) {
      tempFileData.push({
        item_id: openItemId,
        file_data: [fData]
      })
    } else {
      tempFileData.map((data: any) => {
        if (data?.item_id === openItemId) {
          // let oldData = [...data?.file_Data]
          data?.file_data.push(fData)
        }
      })
    }

    setFinalFileData(tempFileData);
  };

  const handleEditFileList = (index: number, itemId: number) => {
    const tempFileData = JSON.parse(JSON.stringify(finalFileData));

    const isFilePresent = tempFileData?.map((file: ItemDataType) => {
      return file?.file_data?.find((item: FileDataType, idx: number) => (
        idx === index
      ))
    });

    let newData: any = [];
    if (isFilePresent) {
      tempFileData?.map((file: ItemDataType) => {
        newData = file?.file_data?.filter((item: FileDataType, idx: number) => (
          idx !== index
        ))
      });

      tempFileData?.map((file: ItemDataType) => {
        if (file?.item_id === itemId) {
          file['file_data'] = [...newData];
        }
      });

      setFinalFileData(tempFileData);
    };
  }

  const handleSubmitClientOpenItems = () => {
    if (token && finalFileData.length) {
      let finalData: UploadOpenItemsPayload = {
        token,
        openItemId: adminOpenItemSingle?.open_item_id,
        item_data: finalFileData
      }
      dispatchUploadClientOpenItemAction(finalData)
    }
  };

  const renderCommentsModal = (data?: any) => {
    setItemId(data?.item_id)
    setCommentsModalData(data);
    if (token && data?.item_id) {
      let finalData: GetAllOpenItemCommentsPayload = {
        item_id: data?.item_id,
        token,
        open_item_id: +jobId
      }
      dispatchGetAllOpenItemCommentsAction(finalData)
    }
  }

  const handleAddOpenItemComment = (data: any) => {
    let finalData: AddOpenItemCommentPayload = {
      token,
      item_id: data?.id,
      open_item_id: +jobId,
      comment: data?.commentText
    }

    dispatchAddOpenItemCommentsAction(finalData);
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetOpenItemsError();
            }}
          />
        )
      }
    }

    if (commentsSuccess === 1) {
      dispatchResetOpenItemsSuccess();
      toast.success('Comment Added Successfully!', {
        duration: 2000
      });
      let finalData: GetAllOpenItemCommentsPayload = {
        item_id: itemId ? itemId : 0,
        token,
        open_item_id: +jobId
      }
      dispatchGetAllOpenItemCommentsAction(finalData);
    } else if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Items Submitted Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetOpenItemsSuccess();
            setFinalFileData([]);
            history.goBack();
          }}
        />
      )
    }

    return false;
  }

  return (
    <>
      <div className='row'>
        <div className="col-md-8 mb-3">
          <CommonHeader title="View Open Item" />
        </div>
      </div>
      <div className="content-area">
        <div className="row">
          <div className="col-md-4">
            <h6>Job Type</h6>
            <p>{`${ adminOpenItemSingle?.job_type } (${ adminOpenItemSingle?.job_id })`}</p>
          </div>
          <div className="col-md-8">
            <h6>Summary</h6>
            <p>{adminOpenItemSingle?.summary}</p>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-12">
            <ClientDocumentSummary
              headers={DocumentSummaryHeader}
              adminOpenItemSingle={adminOpenItemSingle}
              toggleFileUploadModal={handleToggleFileUploadModal}
              handleSetOpenItemId={handleSetOpenItemId}
              fileData={finalFileData}
              toggleCommentModal={handleToggleCommentsModal}
              renderCommentsModal={renderCommentsModal}
              handleEditFileList={handleEditFileList}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12 text-right">
            <button
              className="btn btn-link"
              onClick={() => {
                history.goBack();
                setFinalFileData([]);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmitClientOpenItems}
              disabled={!finalFileData.length}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      {
        showFileUploadModal && <UploadModal
          isDraggableModal
          fetchNewData={() => { }}
          modal={showFileUploadModal}
          toggleModal={handleToggleFileUploadModal}
          client_code={+client_code}
          handleUploadFile={handleUploadedFileData}
        />
      }
      {
        showCommentModal && <CommentsModal
          modal={showCommentModal}
          toggleModal={handleToggleCommentsModal}
          characterLength={150}
          showInputBox={true}
          data={commentsModalData}
          handlePostComment={handleAddOpenItemComment}
          commentFetching={commentsFetching}
          commentsSuccess={commentsSuccess}
          allOpenItemComments={allOpenItemComments}
        />
      }
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </>
  )
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.openItems.fetching,
  commentsFetching: state.openItems.commentsFetching,
  success: state.openItems.success,
  error: state.openItems.error,
  adminOpenItemSingle: state.openItems.adminOpenItemSingle,
  statusCode: state.openItems.statusCode,
  commentsSuccess: state.openItems.commentsSuccess,
  openItemsCommentsList: state.openItems.openItemsCommentsList
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetOpenItemsError: () => dispatch(resetOpenItemsError()),
  dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
  dispatchGetSingleOpenItem: (data: GetSingleOpenItemPayload) => dispatch(getAdminOpenItemsSingleAction(data)),
  dispatchUploadClientOpenItemAction: (data: UploadOpenItemsPayload) =>
    dispatch(uploadClientOpenItemsAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchAddOpenItemCommentsAction: (data: AddOpenItemCommentPayload) =>
    dispatch(addOpenItemCommentsAction(data)),
  dispatchGetAllOpenItemCommentsAction: (data: GetAllOpenItemCommentsPayload) =>
    dispatch(getAllOpenItemCommentsAction(data)),
  dispatchResetOpenItemCommentsListAction: () => dispatch(resetOpenItemsCommentList())
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientViewOpenItem);